<template>
  <ul
    class="sam-icon-list"
    :style="injectedStyles"
  >
    <template v-for="(item, index) in parsedItems">
      <template v-if="$slots.default">
        <slot v-bind="{ item, index }" />
      </template>
      <template v-else>
        <!--
            Triggered on clicking the default slotted child
            @event item-click
            @property {object} item - the item that was selected
          -->
        <SamIconListItem
          :key="`icon_list_item_${index}`"
          :item="item"
          :frame-style="frameStyle"
          @click="$emit('item-click', { ...item, $event })"
        />
      </template>
    </template>
  </ul>
</template>

<script>
import SamIconListItem, {
  FRAME_BACKGROUND_STYLE,
} from './SamIconListItem.vue';

export default {
  name: 'SamIconList',
  components: { SamIconListItem },
  props: {
    /**
     * The items to be shown on the icon list. They must follow a specific structure.
     * @type {[SamIconListItem]}
     */
    items: {
      required: true,
      type: Array,
      default: () => [],
    },
    /**
     * Number of columns for the icon grid
     */
    cols: {
      type: Number,
      required: false,
      default: 2,
    },
    /**
     * The size (in px) of the grid's column
     */
    colSize: {
      type: Number,
      required: false,
      default: 104,
    },
    /**
     * The style to be applied to the icon frame
     */
    frameStyle: {
      type: String,
      required: false,
      default: FRAME_BACKGROUND_STYLE.DEFAULT,
      validator: (val) => Object.values(FRAME_BACKGROUND_STYLE).includes(val),
    },
  },
  computed: {
    parsedItems() {
      return this.items.map((item) => ({
        icon: item.icon,
        label: item.label,
        disabled: item.disabled,
        value: item.value,
      }));
    },
    injectedStyles() {
      return {
        '--cols-number': this.cols,
        '--col-size': `${this.colSize}px`,
      };
    },
  },
};
</script>

<style scoped lang="scss">
.sam-icon-list {
  display: grid;
  grid-template-columns: repeat(var(--cols-number), var(--col-size));
  grid-gap: $size--2;
  padding: $size--2;
}
</style>
